import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, label = "Image", testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-[#333333] mb-1">{label}</label>
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={fileUrl(value)} alt="preview" className="h-16 w-24 object-cover rounded-md border border-[#E5E7EB]" />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-0.5"
              data-testid={`${testid}-remove`}
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ) : (
          <div className="h-16 w-24 rounded-md border border-dashed border-[#E5E7EB] flex items-center justify-center text-gray-300 text-xs">
            No image
          </div>
        )}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`${testid}-btn`}
          className="inline-flex items-center gap-2 text-sm border border-[#1E63C4] text-[#1E63C4] rounded-md px-3 py-2 hover:bg-blue-50 transition-colors disabled:opacity-60"
        >
          <Upload className="h-4 w-4" /> {busy ? "Uploading…" : "Upload"}
        </button>
        <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" />
      </div>
    </div>
  );
}
